import { useEffect } from "react";

export const useScreenOrientationChange = ({
  callback,
}: {
  callback: (event: ScreenOrientationEventMap["change"]) => void;
}) => {
  useEffect(() => {
    if (window.screen && window.screen.orientation) {
      window.screen.orientation.addEventListener("change", callback);
    }

    return () => {
      if (window.screen && window.screen.orientation) {
        window.screen.orientation.removeEventListener("change", callback);
      }
    };
  }, [callback]);
};
